module.exports = __webpack_public_path__ + "static/media/reception7.e7a4ef2e.jpg";